import React, { useState, useEffect } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import ToastNotification from '../../../components/ToastNotification';
import { FaEquals } from 'react-icons/fa';
import { MdEdit } from "react-icons/md";
import { Modal, Button, Table, Form } from "react-bootstrap";
import Select from "react-select";


const StockTransfer = () => {

    const getCurrentDateTime = () => {
        const now = new Date();

        const istOffset = 5.5 * 60;
        const localOffset = now.getTimezoneOffset();
        const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0");
        const day = String(istTime.getDate()).padStart(2, "0");
        const hours = String(istTime.getHours()).padStart(2, "0");
        const minutes = String(istTime.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const [stockTransfer, setStockTransfer] = useState({

        from_branch: '',
        transfer_date: getCurrentDateTime(),
        destination_branch: '',
        remark: '',
        total: '',

    })

    const [formData, setFormData] = useState([
        {
            id: '',
            qty: '',
            name: "",
            rate: '',
            amount: '',

        }
    ]);

    const [files, setFiles] = useState({
        file: null,
        existing_file: null,

    })
    const [isEditMode, setIsEditMode] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [user, setUser] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [detail, setDetail] = useState([]);
    const [getStock, setGetStock] = useState([]);
    const [selecteds, setSelecteds] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);


    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setStockTransfer(prev => ({ ...prev, [name]: value }));
    };

    const totalAmount = formData.reduce(
        (sum, item) => sum + (Number(item.amount) || 0),
        0
    );



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 2) {
                setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };


    const fectshDetail = async () => {
        try {
            const ressloyee = await axios.get('https://api.skyguard.group/api/fetch-sloyee');
            setUser(ressloyee.data.result);

        } catch (error) {
            console.log(error)
        }
    };
    const fecthInventoryDetail = async () => {
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
            const items = resInventory.data.result || [];
            setItems(items);

        } catch (error) {
            console.log(error)
        }
    };

    useEffect(() => {

        fectshDetail();
        fecthInventoryDetail();
        fecthBranchDetail();
        fecthStockTransferDetail();

    }, []);


    const handleSelectChange = (e) => {
        const selectedId = e.target.value;
        setSelectedItemId(selectedId);

        if (!selectedId) return;

        const selectedItem = items.find((item) => item.id === Number(selectedId));

        if (!selectedItem) return;


        if (formData.some((f) => f.id === selectedItem.id)) {
            alert("Item already added!");
            return;
        }
        const newItem = {
            id: selectedItem.id,
            name: selectedItem.name,
            qty: '',
            rate: '',
            amount: '',
        };

        setFormData([...formData, newItem]);
    };

    const handleEdit = (s) => {

        let parsedItems = [];
        try {
            parsedItems = s.items ? JSON.parse(s.items) : [];
        } catch (err) {
            console.error("❌ Error parsing items JSON:", err);
        }

        setStockTransfer({
            id: s.id || '',
            from_branch: s.from_branch || '',
            transfer_date: s.transfer_date ? (s.transfer_date.length === 10 ? `${s.transfer_date}T00:00` : s.transfer_date.replace(' ', 'T').slice(0, 16)) : '',

            destination_branch: s.destination_branch || '',
            remark: s.remark || '',
            total: s.total || '',
        });

        setFormData(parsedItems);

        setFiles({
            file: null,
            existing_file: s.file || null,
        });

        setSelectedItemId(s.id);
        setIsEditMode(true);
        setShowAddForm(true);
    };



    const fecthBranchDetail = async () => {
        try {
            const resBranch = await axios.get('https://api.skyguard.group/api/fetch-branch');


            setDetail(resBranch.data.result);

        } catch (error) {
            console.log(error)
        }
    };




    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendData = new FormData();
        sendData.append("from_branch", stockTransfer.from_branch);
        sendData.append("destination_branch", stockTransfer.destination_branch);
        sendData.append("remark", stockTransfer.remark);
        sendData.append("transfer_date", stockTransfer.transfer_date || new Date().toISOString().split("T")[0]);
        sendData.append("total", totalAmount.toFixed(2));
        sendData.append("items", JSON.stringify(formData));



        sendData.append("existing_file", files.existing_file || "");

        if (files.file) {

            sendData.append("file", files.file);
        }

        try {
            if (isEditMode) {
                await axios.put(
                    `https://api.skyguard.group/api/stock-transfer/${stockTransfer.id}`,
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Stock Transfer updated successfully!", "success");
            } else {
                await axios.post(
                    "https://api.skyguard.group/api/stock-transfer",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Stock Transfer created successfully!", "success");
            }

            fecthStockTransferDetail();
            setShowAddForm(false);
            setIsEditMode(false);

            setStockTransfer({
                from_branch: '',
                transfer_date: getCurrentDateTime(),
                destination_branch: '',
                remark: '',
                total: '',
            })

            setFormData([]);
        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
            showToast(err.response?.data?.error || "Failed to save Stock Transfer!", "danger");
        }
    };

    const fecthStockTransferDetail = async () => {
        try {
            const resBranch = await axios.get('https://api.skyguard.group/api/fetch-transfer-stock');
            const sortedData = Array.isArray(resBranch.data)
                ? [...resBranch.data].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
                : resBranch.data;
            setGetStock(sortedData);
            console.log(resBranch.data)
        } catch (error) {
            console.log(error)
        }
    };


    const filterStock = getStock.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt.from_branch_name && tt.from_branch_name.toLowerCase().includes(term)) ||
            (tt.destination_branch_name && tt.destination_branch_name.toLowerCase().includes(term))
        );
    });

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Stock Transfer Note</h3>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />

                    <div className="mb-3 row gx-2 gy-2 d-flex justify-content-between">


                        <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">

                            <div class="col-12 col-md-9">
                                <div className="row my-3 align-items-center">


                                    {/* Input */}
                                    <div className="col-md-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search By Branch name"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>



                            </div>

                            <div className="col-12 col-md-2 d-flex justify-content-end">
                                <button
                                    className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => {
                                        setShowAddForm(!showAddForm);

                                    }}
                                >
                                    {showAddForm ? 'Cancel' : 'Add'}{' '}
                                    {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
                                </button>
                            </div>

                        </div>





                    </div>

                    {showAddForm && (
                        <div className='card p-3 mb-4'>
                            <h5 className="mb-3">Add Stock Transfer Note  </h5>
                            <form className='row g-3' onSubmit={handleSubmit} >


                            <div className="col-md-4">
                                    <label>Stock Transfer From:</label>

                                    <select
                                        className="form-control"
                                        name="from_branch"
                                        value={stockTransfer.from_branch}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">-- Select Type --</option>
                                        {detail.map((t, index) => (
                                            <option key={index} value={t.id}>
                                                {t.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label>Stock Transfer To:</label>
                                    <select
                                        className="form-control"
                                        name="destination_branch"
                                        value={stockTransfer.destination_branch}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">-- Select Type --</option>
                                        {detail.map((t, index) => (
                                            <option key={index} value={t.id}>
                                                {t.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>


                                <div className="col-md-4">
                                    <laebl>Date</laebl>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="transfer_date"
                                        value={stockTransfer.transfer_date}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>Items:</label>

                                    <Select
                                        options={items.map(item => ({
                                            value: item.id,
                                            label: item.name,
                                            data: item
                                        }))}
                                        value={items
                                            .filter(item => item.id === selectedItemId)
                                            .map(item => ({ value: item.id, label: item.name }))[0] || null}
                                        onChange={selectedOption => {
                                            const itemData = selectedOption?.data;
                                            if (itemData) {
                                                const purchaseCost = Number(itemData.rate) || 0;
                                                // Avoid duplicates
                                                if (!formData.find(f => f.id === itemData.id)) {
                                                    setFormData([
                                                        ...formData,
                                                        { id: itemData.id, name: itemData.name, qty: 0, rate: purchaseCost, amount: 0 }
                                                    ]);
                                                }
                                            }
                                            setSelectedItemId(selectedOption?.value || null);
                                        }}
                                        placeholder="-- Select item --"
                                        isClearable
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label>Upload attachment</label>

                                    {isEditMode && files.existing_file && (
                                        <div className="mt-2">
                                            <small>Current File:</small>
                                            <a
                                                href={`https://api.skyguard.group/uploads/${files.existing_file}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {files.existing_file}
                                            </a>
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="attachment"
                                        name="file"
                                        accept="image/*,application/pdf"
                                        onChange={handleFileChange}
                                    />

                                </div>

                                <div className="row mt-2">


                                    <Table className="col-md-12 table table-bordered text-center align-middle w-75">
                                        <thead className="table-primary">
                                            <tr>
                                                <th style={{ width: '40%' }}>Item Name</th>
                                                <th style={{ width: '15%' }}>Qty</th>
                                                <th style={{ width: '15%' }}>Rate</th>
                                                <th style={{ width: '15%' }}>Amount</th>
                                                <th style={{ width: '15%' }}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {formData.map((item, idx) => (
                                                item.name && (
                                                    <tr key={idx}>
                                                        <td style={{ width: '40%', textAlign: 'left' }}>{item.name}</td>

                                                        {/* Qty */}
                                                        <td style={{ width: '15%' }}>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.qty || ''}
                                                                onChange={(e) => {
                                                                    const updated = [...formData];
                                                                    const qty = Number(e.target.value) || 0;
                                                                    const rate = Number(updated[idx].rate) || 0;
                                                                    updated[idx] = { ...updated[idx], qty, amount: qty * rate };
                                                                    setFormData(updated);
                                                                }}
                                                            />
                                                        </td>

                                                        {/* Rate */}
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.rate}
                                                                onChange={(e) => {
                                                                    const updated = [...formData]; // copy the array
                                                                    const rateStr = e.target.value; // keep string for sty input
                                                                    const rate = rateStr === '' ? '' : Number(rateStr); // number or sty
                                                                    const qty = Number(updated[idx].qty) || 0; // qty number
                                                                    const amount = rate === '' ? 0 : qty * rate;
                                                                    updated[idx] = { ...updated[idx], rate, amount };
                                                                    setFormData(updated);
                                                                }}


                                                            />
                                                        </td>

                                                        {/* Amount (read-only) */}
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.amount || 0}
                                                                readOnly
                                                            />
                                                        </td>

                                                        {/* Delete button */}
                                                        <td>
                                                            <button
                                                                className="btn btn-danger"
                                                                onClick={() => setFormData(formData.filter((_, i) => i !== idx))}
                                                            >
                                                                Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            ))}
                                        </tbody>

                                        {/* Table Footer for Total */}
                                        <tfoot>
                                            <tr>
                                                <td colSpan="3" className="text-end fw-bold">
                                                    Total
                                                </td>
                                                <td colSpan="2">
                                                    <input
                                                        type="text"
                                                        className="form-control text-end fw-bold"
                                                        value={totalAmount.toFixed(2)}
                                                        readOnly
                                                    />
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </Table>


                                </div>



                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Remark</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows="5"
                                            placeholder="Enter description here..."
                                            name="remark"
                                            value={stockTransfer.remark}
                                            onChange={handleInputChange}
                                        ></textarea>
                                    </div>


                                </div>



                                <div className="col-md-12 d-grid d-flex justify-content-end">

                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowAddForm(false);
                                        setIsEditMode(false);
                                        setStockTransfer({
                                            from_branch: '',
                                            transfer_date: getCurrentDateTime(),
                                            destination_branch: '',
                                            remark: '',
                                            total: '',
                                        });
                                        setFormData([]);
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* table */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th scope='col'>SN</th>
                                        <th scope='col'>Action</th>
                                    <th scope='col'>From Branch </th>
                                    <th scope='col'>To Branch</th>
                                    <th scope='col'>Date</th>
                                  
                                </tr>
                            </thead>
                            <tbody>
                                {filterStock.map((s, idx) => (
                                    <tr key={idx}>
                                        <td>{idx + 1}</td>
                                             <td>
                                            <button type="button"
                                                className='btn btn-primary mx-2'
                                                onClick={() => handleEdit(s)}

                                            >

                                                <AiOutlineEdit size={20} title='Edit' />
                                            </button>
                                        </td>
                                        <td>{s.from_branch_name}</td>
                                        <td>{s.destination_branch_name}</td>
                                        <td> {s.transfer_date} </td>

                                   
                                    </tr>
                                ))}

                                {filterStock.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className='text-center text-muted'>
                                            No records found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </>
    )
}

export default StockTransfer
